var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgRequiereOtraPropuesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CD3F39"
    },
    points: "512,155.83 417.701,250.129 512,344.439 323.391,344.439 323.391,289.28 220.991,158.071 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F14742"
    },
    points: "323.391,158.071 323.391,289.28 22.733,289.28 22.733,45.511 323.391,45.511 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6FC5D6"
    },
    points: "45.488,255.147 45.488,512 0,512 0,289.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FC5D6"
    },
    d: "M45.488,7.964v71.68L0,45.511V7.964C0,3.561,3.561,0,7.964,0h29.559 C41.927,0,45.488,3.561,45.488,7.964z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 45.511,
    style: {
      fill: "#CD3F39"
    },
    width: 45.488,
    height: 243.769
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRequiereOtraPropuesta);
export default __webpack_public_path__ + "static/media/bg-requiere-otra-propuesta.5538940c5945238cecc47865dafa59db.svg";
export { ForwardRef as ReactComponent };